import {
	FETCH_CLIENT_BEGIN,
	FETCH_CLIENT_SUCCESS,
	FETCH_CLIENT_ERROR,
	FETCH_CLIENTLIST_BEGIN,
	FETCH_CLIENTLIST_SUCCESS,
	FETCH_CLIENTLIST_ERROR,
	FETCH_VEHICULELIST_BEGIN,
	FETCH_VEHICULELIST_ERROR,
	FETCH_VEHICULELIST_SUCCESS,
	POST_CLIENT_BEGIN,
	POST_CLIENT_ERROR,
	POST_CLIENT_SUCCESS,
	POST_CLIENT_RESET,
	FETCH_CLIENTS_FROM_VEHICULE_BEGIN,
	FETCH_CLIENTS_FROM_VEHICULE_SUCCESS,
	FETCH_CLIENTS_FROM_VEHICULE_ERROR,
	FETCH_CLIENTVEHICULES_BEGIN,
	FETCH_CLIENTVEHICULES_SUCCESS,
	FETCH_CLIENTVEHICULES_ERROR,
	POST_CLIENTVEHICULES_BEGIN,
	POST_CLIENTVEHICULES_RESET,
	POST_CLIENTVEHICULES_ERROR,
	POST_CLIENTVEHICULES_SUCCESS,
	FETCH_ATELIER_BEGIN,
	FETCH_ATELIER_SUCCESS,
	FETCH_ATELIER_ERROR,
	FETCH_ATELIER_RESET,
	POST_ATELIER_BEGIN,
	POST_ATELIER_ERROR,
	POST_ATELIER_SUCCESS,
	POST_ATELIER_RESET,
	POST_ATELIER_ERRORFIELD,
	FETCH_ATELIERSTATE_BEGIN,
	FETCH_ATELIERSTATE_SUCCESS,
	FETCH_ATELIERSTATE_ERROR,
	FETCH_ATELIERCOMMENTAIRES_BEGIN,
	FETCH_ATELIERCOMMENTAIRES_ERROR,
	FETCH_ATELIERCOMMENTAIRES_SUCCESS,
	FETCH_ATELIERLIGNES_BEGIN,
	FETCH_ATELIERLIGNES_SUCCESS,
	FETCH_ATELIERLIGNES_ERROR,
	POST_ATELIERLIGNES_BEGIN,
	POST_ATELIERLIGNES_ERROR,
	POST_ATELIERLIGNES_SUCCESS,
	POST_ATELIERLIGNES_RESET,
	FETCH_LOADATELIERMODELE_BEGIN,
	FETCH_LOADATELIERMODELE_ERROR,
	FETCH_LOADATELIERMODELE_SUCCESS,
	FETCH_AL_PA_BEGIN,
	FETCH_AL_PA_ERROR,
	FETCH_AL_PA_RESET,
	FETCH_AL_PA_SUCCESS,
	FETCH_ATELIER_QUANTITES_BEGIN,
	FETCH_ATELIER_QUANTITES_ERROR,
	FETCH_ATELIER_QUANTITES_RESET,
	FETCH_ATELIER_QUANTITES_SUCCESS,
	FETCH_ATELIER_ENTITE_BEGIN,
	FETCH_ATELIER_ENTITE_SUCCESS,
	FETCH_ATELIER_ENTITE_ERROR,
	POST_ATELIER_FILES_BEGIN,
	POST_ATELIER_FILES_SUCCESS,
	POST_ATELIER_FILES_RESET,
	POST_ATELIER_FILES_ERROR,
	DELETE_ATELIER_FILE_BEGIN,
	DELETE_ATELIER_FILE_SUCCESS,
	DELETE_ATELIER_FILE_RESET,
	DELETE_ATELIER_FILE_ERROR,
	DELETE_ATELIER_TRANSACTION_FILE_BEGIN,
	DELETE_ATELIER_TRANSACTION_FILE_SUCCESS,
	DELETE_ATELIER_TRANSACTION_FILE_RESET,
	DELETE_ATELIER_TRANSACTION_FILE_ERROR,
	POST_ATELIER_TRANSACTION_FILE_BEGIN,
	POST_ATELIER_TRANSACTION_FILE_SUCCESS,
	POST_ATELIER_TRANSACTION_FILE_RESET,
	POST_ATELIER_TRANSACTION_FILE_ERROR,
	POST_ATELIER_TRANSACTION_BEGIN,
	POST_ATELIER_TRANSACTION_SUCCESS,
	POST_ATELIER_TRANSACTION_RESET,
	POST_ATELIER_TRANSACTION_ERROR,
	POST_ATELIER_DOC_RESTITUTION_BEGIN,
	POST_ATELIER_DOC_RESTITUTION_SUCCESS,
	POST_ATELIER_DOC_RESTITUTION_ERROR,
	POST_ATELIER_DOC_RESTITUTION_RESET,
	ATELIER_DELETE_DOC_RESTITUTION_DONE,
	ATELIER_DELETE_DOC_RESTITUTION_BEGIN,
	ATELIER_DELETE_DOC_RESTITUTION_RESET,
	FETCH_ATELIER_TRANSACTIONS_BEGIN,
	FETCH_ATELIER_TRANSACTIONS_ERROR,
	FETCH_ATELIER_TRANSACTIONS_SUCCESS,
	FETCH_ATELIER_FILES_SUCCESS,
} from "../actions/atelierActions"
import {
	ADD_ATELIER_HEURE,
	DELETE_ATELIER_HEURE,
	UPDATE_ATELIER_HEURE,
} from "../actions/heureActions"
import { getBaseAtelier, getBaseEntite } from "../../utilities/defaultObjects"
import {
	PAYE_PAR_ASSURANCE,
	PAYE_PAR_CLIENT,
} from "../../components/atelier/AtelierLigneV2"

// FILES TYPES
export const ATELIER_FILE_TYPE_AVANT_REPARATION = 0
export const ATELIER_FILE_TYPE_APRES_REPARATION = 1
export const ATELIER_FILE_TYPE_CALCUL_REPARATION = 2
export const ATELIER_FILE_TYPE_BULLETIN_LIVRAISON = 3
export const ATELIER_FILE_TYPE_DEVIS_SIGNE = 4
export const ATELIER_FILE_TYPE_PHOTO_PIECE = 5
export const ATELIER_FILE_TYPE_AUTRE = 6
export const ATELIER_FILE_TYPE_DEVIS = 7
export const ATELIER_AUDATEX = 1
export const ATELIER_PHOTO_FACTURE = 2

// MAILS TYPES
export const ATELIER_MAIL_ASSURANCE = 0
export const ATELIER_MAIL_EXPERT = 1
export const ATELIER_MAIL_CLIENT = 2

// SETUP TODAY DATE STRING

const defaultClient = {
	id: null,
	nom: "",
	prenom: "",
	type: 0,
	tel: "",
	adresse: "",
	adresse2: "",
	email: "",
	clientVehicules: [],
}

export const getBaseTransaction = () => {
	return {
		id: 0,
		date: "",
		payePar: "",
		payeParSelect: 0,
		quittance: {
			url: "",
			saved: false,
		},
		facture: {
			url: "",
			saved: false,
		},
		details: "",
		adresse: "",
		moyenPaie: 0,
		caissier: 0,
		total: 0,
		raison: "",
	}
}

export const getBaseTransactionV2 = () => {
	return {
		id: null,
		date: "",
		payeParSelect: -1,
		quittance: null,
		facture: null,
		details: "",
		moyenPaie: 0,
		caissier: 0,
		total: 0,
		raison: "",
		location: 0,
		atelier: 0,
		depannage: 0,
		extra_data: {},
	}
}

const initialState = {
	client: Object.assign({}, defaultClient),
	sousTraitants: [],
	entite: getBaseEntite(),
	fetchEntite: {
		loading: false,
		error: false,
	},
	fournitures: [],
	clientList: [],
	clientVehicules: [],
	clientsFromVehicule: [],
	vehiculeList: [],
	vehiculeClients: [],
	atelier: Object.assign({}, getBaseAtelier()),
	atelierLignes: [],
	atelierState: [],
	atelierStatePagination: { count: 0, page: 1, numPages: 1, pageSize: 50 },
	atelierCommentaires: [],
	heures: [],
	ALPA: [],
	fetchALPA: {
		loading: false,
		error: false,
	},
	atelierQuantites: [],
	fetchAtelierQuantites: {
		loading: false,
		error: false,
	},
	fetchClient: {
		loading: false,
		error: false,
	},
	postAtelierFiles: {
		saving: false,
		saved: false,
		error: false,
	},
	deleteAtelierFile: {
		deleting: false,
		deleted: false,
		error: false,
	},
	deleteAtelierDocRestitution: {
		deleting: false,
		deleted: false,
		error: false,
	},
	postAtelierTransactionFile: {
		saving: false,
		saved: false,
		error: false,
	},
	deleteAtelierTransactionFile: {
		deleting: false,
		deleted: false,
		error: false,
	},
	postClient: {
		saving: false,
		saved: false,
		error: false,
	},
	fetchClientsFromVehicule: {
		loading: false,
		error: false,
	},
	fetchClientList: {
		loading: false,
		error: false,
	},
	fetchVehiculeList: {
		loading: false,
		error: false,
	},
	fetchClientVehicules: {
		loading: false,
		error: false,
	},
	postClientVehicules: {
		saving: false,
		saved: false,
		error: false,
	},
	fetchAtelier: {
		loading: false,
		error: false,
	},
	fetchAtelierState: {
		loading: false,
		error: false,
	},
	postAtelierDocRestitution: {
		saving: false,
		saved: false,
		error: false,
	},
	postAtelier: {
		saving: false,
		saved: false,
		error: false,
		errorFields: [],
	},
	fetchAtelierLignes: {
		loading: false,
		error: false,
	},
	fetchAtelierCommentaires: {
		loading: false,
		error: false,
	},
	postAtelierLignes: {
		saving: false,
		saved: false,
		error: false,
	},
}

export default function atelierReducer(state = initialState, action) {
	let nextState
	switch (action.type) {
		case FETCH_ATELIER_FILES_SUCCESS:
			return {
				...state,
				atelier: {
					...state.atelier,
					files: action.payload,
				},
			}
		case DELETE_ATELIER_HEURE:
			return {
				...state,
				heures: [
					...state.heures.slice(0, action.index),
					...state.heures.slice(action.index + 1),
				],
			}
		case ADD_ATELIER_HEURE:
			return {
				...state,
				heures: [...state.heures, action.value],
			}
		case UPDATE_ATELIER_HEURE:
			return {
				...state,
				heures: [
					...state.heures.slice(0, action.index),
					action.value,
					...state.heures.slice(action.index + 1),
				],
			}
		case "RESET_ATELIER":
			return {
				...state,
				entite: getBaseEntite(),
				atelier: Object.assign({}, getBaseAtelier()),
			}
		case FETCH_ATELIER_TRANSACTIONS_BEGIN:
			return {
				...state,
			}
		case FETCH_ATELIER_TRANSACTIONS_ERROR:
			return {
				...state,
			}
		case FETCH_ATELIER_TRANSACTIONS_SUCCESS:
			return {
				...state,
				atelier: {
					...state.atelier,
					ateTransactions: action.payload,
				},
			}
		case ATELIER_DELETE_DOC_RESTITUTION_DONE:
			return {
				...state,
				atelier: {
					...state.atelier,
					doc_restitution: { url: "", saved: false },
				},
				deleteAtelierDocRestitution: {
					deleting: false,
					deleted: true,
					error: false,
				},
			}
		case ATELIER_DELETE_DOC_RESTITUTION_BEGIN:
			return {
				...state,
				deleteAtelierDocRestitution: {
					deleting: true,
					deleted: false,
					error: false,
				},
			}
		case ATELIER_DELETE_DOC_RESTITUTION_RESET:
			return {
				...state,
				deleteAtelierDocRestitution: {
					deleting: false,
					deleted: false,
					error: false,
				},
			}
		case "SET_SOUS_TRAITANTS":
			return {
				...state,
				sousTraitants: action.value,
			}
		case "ADD_FOURNITURE":
			return {
				...state,
				fournitures: [...state.fournitures, action.value],
			}
		case "REMOVE_FOURNITURE":
			let four_index = state.fournitures.findIndex(
				(four) => four.id === action.value,
			)
			return {
				...state,
				fournitures: [
					...state.fournitures.slice(0, four_index),
					...state.fournitures.slice(four_index + 1),
				],
			}
		case POST_ATELIER_DOC_RESTITUTION_BEGIN:
			return {
				...state,
				postAtelierDocRestitution: {
					saving: true,
					saved: false,
					error: false,
				},
			}
		case POST_ATELIER_DOC_RESTITUTION_SUCCESS:
			return {
				...state,
				atelier: action.payload,
				postAtelierDocRestitution: {
					saving: false,
					saved: true,
					error: false,
				},
			}
		case POST_ATELIER_DOC_RESTITUTION_ERROR:
			return {
				...state,
				postAtelierDocRestitution: {
					saving: false,
					saved: false,
					error: action.payload,
				},
			}
		case POST_ATELIER_DOC_RESTITUTION_RESET:
			return {
				...state,
				postAtelierDocRestitution: {
					saving: false,
					saved: false,
					error: false,
				},
			}
		case POST_ATELIER_TRANSACTION_BEGIN:
			return {
				...state,
				postAtelier: {
					saving: true,
					saved: false,
					error: false,
					errorFields: [],
				},
			}
		case POST_ATELIER_TRANSACTION_SUCCESS:
			let index_trans = state.atelier.ateTransactions.findIndex(
				(t) => t.id === action.payload.id,
			)
			if (index_trans === -1) {
				return {
					...state,
					atelier: {
						...state.atelier,
						ateTransactions: [
							...state.atelier.ateTransactions,
							action.payload,
						],
					},
					postAtelier: {
						saving: false,
						saved: true,
						error: false,
						errorFields: [],
					},
				}
			}
			return {
				...state,
				atelier: {
					...state.atelier,
					ateTransactions: [
						...state.atelier.ateTransactions.slice(0, index_trans),
						action.payload,
						...state.atelier.ateTransactions.slice(index_trans + 1),
					],
				},
				postAtelier: {
					saving: false,
					saved: true,
					error: false,
					errorFields: [],
				},
			}
		case POST_ATELIER_TRANSACTION_RESET:
			return {
				...state,
				postAtelier: {
					saving: false,
					saved: false,
					error: false,
					errorFields: [],
				},
			}
		case POST_ATELIER_TRANSACTION_ERROR:
			return {
				...state,
				postAtelier: {
					saving: false,
					saved: false,
					error: action.payload,
				},
			}
		case DELETE_ATELIER_TRANSACTION_FILE_BEGIN:
			return {
				...state,
				deleteAtelierTransactionFile: {
					deleting: true,
					deleted: false,
					error: false,
				},
			}
		case DELETE_ATELIER_TRANSACTION_FILE_SUCCESS:
			let deleted_trans_index = state.atelier.ateTransactions.findIndex(
				(t) => t.id === action.payload.id,
			)
			return {
				...state,
				atelier: {
					...state.atelier,
					ateTransactions: [
						...state.atelier.ateTransactions.slice(
							0,
							deleted_trans_index,
						),
						action.payload,
						...state.atelier.ateTransactions.slice(
							deleted_trans_index + 1,
						),
					],
				},
				deleteAtelierTransactionFile: {
					deleting: false,
					deleted: true,
					error: false,
				},
			}
		case DELETE_ATELIER_TRANSACTION_FILE_RESET:
			return {
				...state,
				deleteAtelierTransactionFile: {
					deleting: false,
					deleted: false,
					error: false,
				},
			}
		case DELETE_ATELIER_TRANSACTION_FILE_ERROR:
			return {
				...state,
				deleteAtelierTransactionFile: {
					deleting: false,
					deleted: false,
					error: action.payload,
				},
			}
		case POST_ATELIER_TRANSACTION_FILE_BEGIN:
			return {
				...state,
				postAtelierTransactionFile: {
					saving: true,
					saved: false,
					error: false,
				},
			}
		case POST_ATELIER_TRANSACTION_FILE_SUCCESS:
			let posted_trans_index = state.atelier.ateTransactions.findIndex(
				(t) => t.id === action.payload.id,
			)
			return {
				...state,
				atelier: {
					...state.atelier,
					ateTransactions: [
						...state.atelier.ateTransactions.slice(
							0,
							posted_trans_index,
						),
						action.payload,
						...state.atelier.ateTransactions.slice(
							posted_trans_index + 1,
						),
					],
				},
				postAtelierTransactionFile: {
					saving: false,
					saved: true,
					error: false,
				},
			}
		case POST_ATELIER_TRANSACTION_FILE_RESET:
			return {
				...state,
				postAtelierTransactionFile: {
					saving: false,
					saved: false,
					error: false,
				},
			}
		case POST_ATELIER_TRANSACTION_FILE_ERROR:
			return {
				...state,
				postAtelierTransactionFile: {
					saving: true,
					saved: false,
					error: action.payload,
				},
			}
		case DELETE_ATELIER_FILE_BEGIN:
			return {
				...state,
				deleteAtelierFile: {
					deleting: true,
					deleted: false,
					error: false,
				},
			}
		case DELETE_ATELIER_FILE_SUCCESS:
			return {
				...state,
				atelier: action.payload,
				deleteAtelierFile: {
					deleting: false,
					deleted: true,
					error: false,
				},
			}
		case DELETE_ATELIER_FILE_RESET:
			return {
				...state,
				deleteAtelierFile: {
					deleting: false,
					deleted: false,
					error: false,
				},
			}
		case DELETE_ATELIER_FILE_ERROR:
			return {
				...state,
				deleteAtelierFile: {
					deleting: false,
					deleted: false,
					error: action.payload,
				},
			}
		case POST_ATELIER_FILES_BEGIN:
			return {
				...state,
				postAtelierFiles: {
					saving: true,
					saved: false,
					error: false,
				},
			}
		case POST_ATELIER_FILES_SUCCESS:
			return {
				...state,
				atelier: {
					...state.atelier,
					files: action.payload,
				},
				postAtelierFiles: {
					saving: false,
					saved: true,
					error: false,
				},
			}
		case POST_ATELIER_FILES_RESET:
			return {
				...state,
				postAtelierFiles: {
					saving: false,
					saved: false,
					error: false,
				},
			}
		case POST_ATELIER_FILES_ERROR:
			return {
				...state,
				postAtelierFiles: {
					saving: true,
					saved: false,
					error: action.payload,
				},
			}
		case FETCH_ATELIER_ENTITE_BEGIN:
			return {
				...state,
				fetchEntite: {
					loading: true,
					error: false,
				},
			}
		case FETCH_ATELIER_ENTITE_SUCCESS:
			return {
				...state,
				entite: action.payload,
				fetchEntite: {
					loading: false,
					error: false,
				},
			}
		case FETCH_ATELIER_ENTITE_ERROR:
			return {
				...state,
				fetchEntite: {
					loading: false,
					error: action.payload,
				},
			}
		case FETCH_LOADATELIERMODELE_BEGIN:
			return {
				...state,
				fetchAtelierLignes: {
					loading: true,
					error: false,
				},
				fetchAtelierCommentaires: {
					loading: true,
					error: false,
				},
			}
		case FETCH_LOADATELIERMODELE_ERROR:
			return {
				...state,
				fetchAtelierLignes: {
					loading: false,
					error: action.payload.error,
				},
				fetchAtelierCommentaires: {
					loading: false,
					error: action.payload.error,
				},
			}
		case FETCH_LOADATELIERMODELE_SUCCESS:
			const { isAssurance } = state.atelier
			const type = isAssurance ? PAYE_PAR_ASSURANCE : PAYE_PAR_CLIENT
			action.payload.data.atelierLignes.forEach((al) => {
				al.id = Math.random()
				al.type = type
			})
			action.payload.data.atelierCommentaires.forEach((al) => {
				al.id = Math.random()
			})
			return {
				...state,
				atelierLignes: [
					...state.atelierLignes,
					...action.payload.data.atelierLignes,
				],
				atelierCommentaires: [
					...state.atelierCommentaires,
					...action.payload.data.atelierCommentaires,
				],
				fetchAtelierLignes: {
					loading: false,
					error: false,
				},
				fetchAtelierCommentaires: {
					loading: false,
					error: false,
				},
			}
		case FETCH_CLIENT_BEGIN:
			return {
				...state,
				fetchClient: {
					loading: true,
					error: false,
				},
			}
		case FETCH_CLIENT_ERROR:
			return {
				...state,
				fetchClient: {
					loading: false,
					error: action.payload.error,
				},
			}
		case FETCH_CLIENT_SUCCESS:
			return {
				...state,
				client: action.payload.client[0],
				fetchClient: {
					loading: false,
					error: false,
				},
			}
		case FETCH_CLIENTS_FROM_VEHICULE_BEGIN:
			return {
				...state,
				fetchClientsFromVehicule: {
					loading: true,
					error: false,
				},
			}
		case FETCH_CLIENTS_FROM_VEHICULE_ERROR:
			return {
				...state,
				fetchClientsFromVehicule: {
					loading: false,
					error: action.payload.error,
				},
			}
		case FETCH_CLIENTS_FROM_VEHICULE_SUCCESS:
			return {
				...state,
				clientsFromVehicule: action.payload.clientsFromVehicule,
				fetchClientsFromVehicule: {
					loading: false,
					error: false,
				},
			}
		case FETCH_CLIENTLIST_BEGIN:
			return {
				...state,
				fetchClientList: {
					loading: true,
					error: false,
				},
			}
		case FETCH_CLIENTLIST_ERROR:
			return {
				...state,
				fetchClientList: {
					loading: false,
					error: action.payload.error,
				},
			}
		case FETCH_CLIENTLIST_SUCCESS:
			return {
				...state,
				clientList: action.payload.clientList.filter(
					(client) => ![7].includes(client.id),
				),
				fetchClientList: {
					loading: false,
					error: false,
				},
			}
		case FETCH_VEHICULELIST_BEGIN:
			return {
				...state,
				fetchVehiculeList: {
					loading: true,
					error: false,
				},
			}
		case FETCH_VEHICULELIST_ERROR:
			return {
				...state,
				fetchVehiculeList: {
					loading: false,
					error: action.payload.error,
				},
			}
		case FETCH_VEHICULELIST_SUCCESS:
			return {
				...state,
				vehiculeList: action.payload.vehiculeList,
				fetchVehiculeList: {
					loading: false,
					error: false,
				},
			}
		case POST_CLIENT_BEGIN:
			return {
				...state,
				postClient: {
					saved: false,
					saving: true,
					error: false,
				},
			}
		case POST_CLIENT_ERROR:
			return {
				...state,
				postClient: {
					saved: false,
					saving: false,
					error: action.payload.error,
				},
			}
		case POST_CLIENT_SUCCESS:
			return {
				...state,
				client: action.payload.client[0],
				postClient: {
					saved: true,
					saving: false,
					error: false,
				},
			}
		case POST_CLIENT_RESET:
			return {
				...state,
				postClient: {
					saved: false,
					saving: false,
					error: false,
				},
			}
		case FETCH_CLIENTVEHICULES_BEGIN:
			return {
				...state,
				fetchClientVehicules: {
					loading: true,
					error: false,
				},
			}
		case FETCH_CLIENTVEHICULES_ERROR:
			return {
				...state,
				fetchClientVehicules: {
					loading: false,
					error: action.payload.error,
				},
			}
		case FETCH_CLIENTVEHICULES_SUCCESS:
			return {
				...state,
				clientVehicules: action.payload.clientVehicules,
				fetchClientVehicules: {
					loading: false,
					error: false,
				},
			}
		case POST_CLIENTVEHICULES_BEGIN:
			return {
				...state,
				postClientVehicules: {
					saved: false,
					saving: true,
					error: false,
				},
			}
		case POST_CLIENTVEHICULES_ERROR:
			return {
				...state,
				postClientVehicules: {
					saved: false,
					saving: false,
					error: action.payload.error,
				},
			}
		case POST_CLIENTVEHICULES_SUCCESS:
			return {
				...state,
				clientVehicules: action.payload.clientVehicules,
				postClientVehicules: {
					saved: true,
					saving: false,
					error: false,
				},
			}
		case POST_CLIENTVEHICULES_RESET:
			return {
				...state,
				postClientVehicules: {
					saved: false,
					saving: false,
					error: false,
				},
			}
		// Atelier
		case FETCH_ATELIER_BEGIN:
			return {
				...state,
				fetchAtelier: {
					loading: true,
					error: false,
				},
			}
		case FETCH_ATELIER_ERROR:
			return {
				...state,
				fetchAtelier: {
					loading: false,
					error: action.payload.error,
				},
			}
		case FETCH_ATELIER_RESET:
			return {
				...state,
				atelier: Object.assign({}, getBaseAtelier()),
				client: Object.assign({}, defaultClient),
				entite: getBaseEntite(),
				clientVehicules: [],
				atelierLignes: [],
				atelierCommentaires: [],
				fournitures: [],
				sousTraitants: [],
				heures: [],
			}
		case FETCH_ATELIER_SUCCESS:
			return {
				...state,
				atelier: action.payload.atelier,
				fournitures: action.payload.fournitures,
				sousTraitants: action.payload.sousTraitants,
				heures: action.payload.heures,
				// Jordan 30.10 : marqueur « soldée » des fiches liées.
				soldesLiees: action.payload.soldes_liees || null,
				fetchAtelier: {
					loading: false,
					error: false,
				},
			}
		case FETCH_ATELIERSTATE_BEGIN:
			return {
				...state,
				fetchAtelierState: {
					loading: true,
					error: false,
				},
			}
		case FETCH_ATELIERSTATE_ERROR:
			return {
				...state,
				fetchAtelierState: {
					loading: false,
					error: action.payload.error,
				},
			}
		case FETCH_ATELIERSTATE_SUCCESS:
			return {
				...state,
				atelierState: action.payload.atelierState,
				atelierStatePagination:
					action.payload.pagination || state.atelierStatePagination,
				fetchAtelierState: {
					loading: false,
					error: false,
				},
			}
		case POST_ATELIER_BEGIN:
			return {
				...state,
				postAtelier: {
					saved: false,
					saving: true,
					error: false,
					errorFields: [],
				},
			}
		case POST_ATELIER_ERROR:
			return {
				...state,
				postAtelier: {
					saved: false,
					saving: false,
					error: action.payload.error,
					errorFields: [],
				},
			}
		case POST_ATELIER_SUCCESS:
			return {
				...state,
				atelier: action.payload.atelier,
				entite: action.payload.entite,
				atelierLignes: action.payload.atelierLignes,
				atelierCommentaires: action.payload.atelierCommentaires,
				fournitures: action.payload.fournitures,
				sousTraitants: action.payload.sousTraitants,
				heures: action.payload.heures,
				soldesLiees: action.payload.soldes_liees || null,
				postAtelier: {
					saved: true,
					saving: false,
					error: false,
					errorFields: [],
				},
			}
		case POST_ATELIER_RESET:
			return {
				...state,
				postAtelier: {
					saved: false,
					saving: false,
					error: false,
					errorFields: [],
				},
			}
		case POST_ATELIER_ERRORFIELD:
			return {
				...state,
				postAtelier: {
					saved: false,
					saving: false,
					error: false,
					errorFields: action.payload.errorFields,
				},
			}
		// Atelier commentaires
		case FETCH_ATELIERCOMMENTAIRES_BEGIN:
			return {
				...state,
				fetchAtelierCommentaires: {
					loading: true,
					error: false,
				},
			}
		case FETCH_ATELIERCOMMENTAIRES_ERROR:
			return {
				...state,
				fetchAtelierCommentaires: {
					loading: false,
					error: action.payload.error,
				},
			}
		case FETCH_ATELIERCOMMENTAIRES_SUCCESS:
			return {
				...state,
				atelierCommentaires: action.payload.atelierCommentaires,
				fetchAtelierCommentaires: {
					loading: false,
					error: false,
				},
			}
		// Atelier lignes
		case FETCH_ATELIERLIGNES_BEGIN:
			return {
				...state,
				fetchAtelierLignes: {
					loading: true,
					error: false,
				},
			}
		case FETCH_ATELIERLIGNES_ERROR:
			return {
				...state,
				fetchAtelierLignes: {
					loading: false,
					error: action.payload.error,
				},
			}
		case FETCH_ATELIERLIGNES_SUCCESS:
			return {
				...state,
				atelierLignes: action.payload.atelierLignes,
				fetchAtelierLignes: {
					loading: false,
					error: false,
				},
			}
		case POST_ATELIERLIGNES_BEGIN:
			return {
				...state,
				postAtelierLignes: {
					saved: false,
					saving: true,
					error: false,
				},
			}
		case POST_ATELIERLIGNES_ERROR:
			return {
				...state,
				postAtelierLignes: {
					saved: false,
					saving: false,
					error: action.payload.error,
				},
			}
		case POST_ATELIERLIGNES_SUCCESS:
			return {
				...state,
				atelierLignes: action.payload.atelierLignes,
				postAtelierLignes: {
					saved: true,
					saving: false,
					error: false,
				},
			}
		case POST_ATELIERLIGNES_RESET:
			return {
				...state,
				postAtelierLignes: {
					saved: false,
					saving: false,
					error: false,
				},
			}
		case FETCH_AL_PA_BEGIN:
			return {
				...state,
				fetchALPA: {
					loading: true,
					error: false,
				},
			}
		case FETCH_AL_PA_ERROR:
			return {
				...state,
				fetchALPA: {
					loading: false,
					error: action.payload.error,
				},
			}
		case FETCH_AL_PA_RESET:
			return {
				...state,
				ALPA: [],
				fetchALPA: {
					loading: false,
					error: false,
				},
			}
		case FETCH_AL_PA_SUCCESS:
			return {
				...state,
				ALPA: action.payload.alpa,
				fetchALPA: {
					loading: false,
					error: false,
				},
			}
		case FETCH_ATELIER_QUANTITES_BEGIN:
			return {
				...state,
				fetchAtelierQuantites: {
					loading: true,
					error: false,
				},
			}
		case FETCH_ATELIER_QUANTITES_ERROR:
			return {
				...state,
				fetchAtelierQuantites: {
					loading: false,
					error: action.payload.error,
				},
			}
		case FETCH_ATELIER_QUANTITES_RESET:
			return {
				...state,
				atelierQuantites: [],
				fetchAtelierQuantites: {
					loading: false,
					error: false,
				},
			}
		case FETCH_ATELIER_QUANTITES_SUCCESS:
			return {
				...state,
				atelierQuantites: action.payload.atelierQuantites,
				fetchAtelierQuantites: {
					loading: false,
					error: false,
				},
			}
		// SET_ATELIER + OTHERS
		case "SET_ATELIER":
			nextState = {
				...state,
				atelier: action.value,
			}
			return nextState
		case "SET_CLIENT":
			nextState = {
				...state,
				client: action.value,
			}
			return nextState
		case "SET_CLIENTVEHICULES":
			let cv = state.clientVehicules
			let cvIndex = cv.findIndex((c) => c.id === action.value.id)
			if (cvIndex !== -1) {
				nextState = {
					...state,
					clientVehicules: [
						...state.clientVehicules.slice(0, cvIndex),
						action.value,
						...state.clientVehicules.slice(cvIndex + 1),
					],
				}
				return nextState
			} else {
				cv.push(action.value)
				return {
					...state,
					clientVehicules: cv,
				}
			}
		case "UPDATE_ATELIERLIGNES":
			return {
				...state,
				atelierLignes: action.value,
			}
		case "SET_ATELIERLIGNES_ATELIERCOMMENTAIRES":
			return {
				...state,
				atelierLignes: action.value.als,
				atelierCommentaires: action.value.acs,
			}
		case "SET_ATELIER_ATELIERLIGNES":
			return {
				...state,
				atelier: action.value.atelier,
				atelierLignes: action.value.als,
			}
		case "SET_ATELIERLIGNES":
			let alInd = state.atelierLignes.findIndex(
				(al) => al.id === action.value.id,
			)
			if (alInd !== -1) {
				return {
					...state,
					atelierLignes: [
						...state.atelierLignes.slice(0, alInd),
						action.value,
						...state.atelierLignes.slice(alInd + 1),
					],
				}
			}
			return { ...state }
		case "REMOVE_ATELIERLIGNE":
			return {
				...state,
				atelierLignes: state.atelierLignes.filter(
					(aL) => aL.id !== action.value,
				),
			}
		case "ADD_ATELIERLIGNES":
			let al = state.atelierLignes
			al.push(action.value)
			return {
				...state,
				atelierLignes: al,
			}
		case "ADD_MANY_ATELIERLIGNES":
			return {
				...state,
				atelierLignes: [...state.atelierLignes, ...action.value],
			}
		case "UPDATE_ATELIERCOMMENTAIRE":
			let aCIndex = state.atelierCommentaires.findIndex(
				(aC) => aC.id === action.value.id,
			)
			if (aCIndex !== -1)
				return {
					...state,
					atelierCommentaires: [
						...state.atelierCommentaires.slice(0, aCIndex),
						action.value,
						...state.atelierCommentaires.slice(aCIndex + 1),
					],
				}
			else
				return {
					...state,
					atelierCommentaires: [
						...state.atelierCommentaires,
						action.value,
					],
				}
		case "REMOVE_ATELIERCOMMENTAIRE":
			return {
				...state,
				atelierCommentaires: state.atelierCommentaires.filter(
					(a) => a.id !== action.value,
				),
			}
		case "REORDER_ALIGNES":
			let dragIndex = state.atelierLignes.findIndex(
				(aL) => aL.id === action.dragId,
			)
			let dropIndex = state.atelierLignes.findIndex(
				(aL) => aL.id === action.dropId,
			)
			if (dragIndex < dropIndex) {
				return {
					...state,
					atelierLignes: [
						...state.atelierLignes.slice(0, dragIndex),
						...state.atelierLignes.slice(
							dragIndex + 1,
							dropIndex + 1,
						),
						state.atelierLignes[dragIndex],
						...state.atelierLignes.slice(dropIndex + 1),
					],
				}
			} else if (dragIndex > dropIndex) {
				return {
					...state,
					atelierLignes: [
						...state.atelierLignes.slice(0, dropIndex),
						state.atelierLignes[dragIndex],
						...state.atelierLignes.slice(dropIndex, dragIndex),
						...state.atelierLignes.slice(dragIndex + 1),
					],
				}
			} else {
				return {
					...state,
				}
			}
		case "REORDER_ACOMS":
			let dragIndex2 = state.atelierCommentaires.findIndex(
				(aL) => aL.id === action.dragId,
			)
			let dropIndex2 = state.atelierCommentaires.findIndex(
				(aL) => aL.id === action.dropId,
			)
			if (dragIndex2 < dropIndex2) {
				return {
					...state,
					atelierCommentaires: [
						...state.atelierCommentaires.slice(0, dragIndex2),
						...state.atelierCommentaires.slice(
							dragIndex2 + 1,
							dropIndex2 + 1,
						),
						state.atelierCommentaires[dragIndex2],
						...state.atelierCommentaires.slice(dropIndex2 + 1),
					],
				}
			} else if (dragIndex2 > dropIndex2) {
				return {
					...state,
					atelierCommentaires: [
						...state.atelierCommentaires.slice(0, dropIndex2),
						state.atelierCommentaires[dragIndex2],
						...state.atelierCommentaires.slice(
							dropIndex2,
							dragIndex2,
						),
						...state.atelierCommentaires.slice(dragIndex2 + 1),
					],
				}
			} else {
				return {
					...state,
				}
			}
		case "REMOVE_ATELIER_TRANSACTION":
			nextState = {
				...state,
				atelier: {
					...state.atelier,
					ateTransactions: state.atelier.ateTransactions.filter(
						(transaction) => transaction.id !== action.value,
					),
				},
			}
			return nextState
		case "SET_ATELIER_TRANSACTION":
			const transactionIndex = state.atelier.ateTransactions.findIndex(
				(transaction) => transaction.id === action.value.id,
			)
			if (transactionIndex !== -1) {
				let tempateTransactions = [
					...state.atelier.ateTransactions.slice(0, transactionIndex),
					action.value,
					...state.atelier.ateTransactions.slice(
						transactionIndex + 1,
					),
				]
				nextState = {
					...state,
					atelier: {
						...state.atelier,
						ateTransactions: tempateTransactions,
					},
				}
				return nextState
			} else {
				nextState = {
					...state,
					atelier: {
						...state.atelier,
						ateTransactions: [
							...state.atelier.ateTransactions,
							action.value,
						],
					},
				}
				return nextState
			}
		default:
			return state
	}
}
